import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=14320997&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=js&"
export * from "./MyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14320997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14320997')) {
      api.createRecord('14320997', component.options)
    } else {
      api.reload('14320997', component.options)
    }
    module.hot.accept("./MyAccount.vue?vue&type=template&id=14320997&scoped=true&", function () {
      api.rerender('14320997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MyAccount.vue"
export default component.exports